import { render, staticRenderFns } from "./Tabset.vue?vue&type=template&id=57440b06"
import script from "./Tabset.vue?vue&type=script&lang=js"
export * from "./Tabset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports